import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import { TestID } from '../../../../utils/PropTypesDefinitions'
import PlayerImage from '../../../../BaseComponents/Image/Player'
import SmallBodyFont from '../../../../Theme/Fonts/SmallBody'
import {
    Goal,
    RedCard,
    SecondYellowCard,
    Substitution,
    VideoProof,
    Whistle,
    YellowCard,
} from '../../HelperClass/Icons'
import { AdditionaInfoIcons } from './PlayerTypes'

type Transfertypes = 'TRANSFER_IN' | 'TRANSFER_OUT'
type TeamMemberProps = {
    name: string
    imageUrl?: string
    jerseyNumber?: number
    showBorderTop?: boolean
    additionalInfoIconsList?: AdditionaInfoIcons[] | AdditionaInfoIcons
    transfer?: Transfertypes
    substitutionMinute?: string
    onPressRow?: () => void
    imageAlt?: string
    showBorderBottom?: boolean
} & TestID

const mapTransferIcons = (transfer: Transfertypes) => {
    if (transfer === 'TRANSFER_OUT') {
        return <FontelloIcon name="arrow-bottom" fontSize={14} color="RED" />
    }
    return <FontelloIcon name="arrow-top" fontSize={14} color="GREEN" />
}
const mapIcons = (
    additionalInfoIconsList: AdditionaInfoIcons[] | AdditionaInfoIcons,
    name: string
) => {
    const icons = Array.isArray(additionalInfoIconsList)
        ? additionalInfoIconsList
        : [additionalInfoIconsList]
    const result = icons?.map((iconType: AdditionaInfoIcons, index) => {
        if (iconType === 'YELLOW_CARD') {
            return <YellowCard fontSize="FS12" />
        }
        if (iconType === 'RED_CARD') {
            return <RedCard fontSize="FS12" />
        }
        if (iconType === 'SECOND_YELLOW_CARD') {
            return <SecondYellowCard fontSize="FS12" />
        }
        if (iconType === 'SUBSTITUTION') {
            return <Substitution fontSize="FS12" />
        }
        if (iconType === 'WHISTLE') {
            return <Whistle fontSize="FS12" />
        }
        if (iconType === 'GOAL') {
            return <Goal fontSize="FS12" />
        }
        return <VideoProof key={index} fontSize="FS12" />
    })
    return (
        <Grid noExpand alignRight horizontal centerVertical>
            {result.map((icon, index) => {
                return (
                    <Grid key={`icon${index}_${name}`} noExpand marginLeft={2}>
                        {icon}
                    </Grid>
                )
            })}
        </Grid>
    )
}
const TeamMemberTemplate: FunctionComponent<TeamMemberProps> = ({
    name,
    imageUrl,
    jerseyNumber,
    showBorderTop = true,
    additionalInfoIconsList,
    transfer,
    substitutionMinute,
    onPressRow,
    testID,
    imageAlt,
    showBorderBottom,
}) => {
    const mapTextValue = (leftSideText?: number | string) => {
        return (
            <SmallBodyFont
                bold={!!jerseyNumber}
                textAlign="left"
                color="onyx-4"
            >{`${leftSideText}`}</SmallBodyFont>
        )
    }
    return (
        <Grid testID={testID} backgroundColor="pearl">
            <Touchable expand onPress={onPressRow}>
                <Grid
                    paddingY={3}
                    borderTop={showBorderTop ? '1px' : '0px'}
                    borderColor="moon-2"
                    borderBottom={showBorderBottom ? '1px' : '0px'}
                    horizontal
                >
                    <Grid width={24} centerVertical noExpand>
                        {jerseyNumber || substitutionMinute
                            ? mapTextValue(jerseyNumber || substitutionMinute)
                            : undefined}
                    </Grid>
                    <PlayerImage imageUrl={imageUrl} alt={imageAlt} size="S" width={32} />
                    <Grid paddingX={3} minWidth={0} centerVertical>
                        <SmallBodyFont numberOfLines={1} textAlign="left">
                            {name}
                        </SmallBodyFont>
                    </Grid>

                    {transfer ? (
                        <Grid noExpand centerVertical>
                            {mapTransferIcons(transfer)}
                        </Grid>
                    ) : undefined}
                    {additionalInfoIconsList && mapIcons(additionalInfoIconsList, name)}
                </Grid>
            </Touchable>
        </Grid>
    )
}

export default TeamMemberTemplate
